export function getNestedTranslation(primaryMessage, nestedTranslations) {
    const nestedOptions = {};
    let doesNestedStringHaveInputVariables = false;
    for(const key in nestedTranslations){
        const nestedMessages = nestedTranslations[key];
        const nestedString = Array.isArray(nestedMessages) ? getNestedTranslationStrings(nestedMessages) : getNestedTranslationString(nestedMessages);
        nestedOptions[`${key}`] = nestedString;
        if (doNestedMessageHaveInputVariables(nestedMessages)) doesNestedStringHaveInputVariables = true;
    }
    const translationObject = {
        key: primaryMessage.key,
        options: {
            ...primaryMessage.options,
            ...nestedOptions,
            interpolation: {
                escapeValue: !doesNestedStringHaveInputVariables
            }
        }
    };
    return translationObject;
}
function getNestedTranslationString(translationObject) {
    // eslint-disable-next-line
    return `$t(${translationObject.key}, ${JSON.stringify(translationObject.options)})`;
}
function getNestedTranslationStrings(translationObjects) {
    const translationStrings = [];
    for (const translationObject of translationObjects){
        translationStrings.push(getNestedTranslationString(translationObject));
    }
    return translationStrings;
}
function doNestedMessageHaveInputVariables(nestedMessages) {
    const stringsToCheck = Array.isArray(nestedMessages) ? nestedMessages : [
        nestedMessages
    ];
    for (const stringToCheck of stringsToCheck){
        if (stringToCheck.options != undefined) return true;
    }
    return false;
}
